import { render, staticRenderFns } from "./ProductBundleList.vue?vue&type=template&id=e4efaa70&scoped=true&"
import script from "./ProductBundleList.vue?vue&type=script&lang=js&"
export * from "./ProductBundleList.vue?vue&type=script&lang=js&"
import style0 from "./ProductBundleList.vue?vue&type=style&index=0&id=e4efaa70&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4efaa70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconPlus: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconPlus.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default,SvgIconCircle: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCircle.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
